module.exports = __webpack_public_path__ + "static/icon_life_saving_gift_process_01@2x-1211a2eb95879bfda8b41924b0efb33b.png";